import { ICompatibilityResult, ISingleEpletMmRisk } from '@nkr/models/index';

export default interface ICompatibilityResultWithEpletMmRisk extends ICompatibilityResult {
    singleEpletMmRisk: ISingleEpletMmRisk
}